import React from "react";
import Seo, { ORGANIZATION_JSONLD } from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import PartnerStrip from "@/components/sections/PartnerStrip";
import SolutionsGrid from "@/components/sections/SolutionsGrid";
import WhyCloudBeaker from "@/components/sections/WhyCloudBeaker";
import ServicePillars from "@/components/sections/ServicePillars";
import CtaBand from "@/components/sections/CtaBand";
import CloudJourney from "@/components/sections/CloudJourney";

export default function Home() {
  return (
    <>
      <Seo
        title="One Partner. Every Cloud. No Guesswork."
        description="Cloud Beaker helps organizations architect, migrate, modernize and operate across Google Cloud, Microsoft Azure and Alibaba Cloud with strategy, engineering and managed services."
        path="/"
        jsonLd={ORGANIZATION_JSONLD}
      />
      <Hero />
      <PartnerStrip />
      <SolutionsGrid />
      <WhyCloudBeaker />
      <ServicePillars />
      <CtaBand />
      <CloudJourney />
    </>
  );
}
